import { PAGE_ANALYTICS_INFO } from '../page-types'
import type { RouteLocationNormalized } from 'vue-router'
/* ------- MICROFRONT - CHECKOUT ------- */

export const orderConfirmationRoute = [
  {
    path: '/order-confirmation/:checkoutId',
    name: 'checkout-v2-order-confirmation',
    component: () => import('@b2ag/micro-front-checkout-v2/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'checkout-v2',
      viewName: 'order-confirmation',
      checkoutId: route.params.checkoutId,
    }),
    meta: {
      private: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.CHECKOUT,
    },
  },
]

export const checkoutRoutes = [
  {
    path: '/checkout/:checkoutId',
    name: 'checkout-v2',
    component: () => import('@b2ag/micro-front-checkout-v2/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'checkout-v2',
      viewName: 'checkout',
      checkoutId: route.params.checkoutId,
    }),
    meta: {
      private: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.CHECKOUT,
      layout: 'default',
    },
  },
]
